<template>
  <div class="small-card">
    <div class="name">{{ item.name }}</div>
    <div class="complete-data">
      <div class="value">{{ item.val }}</div>
      <div class="tendency">
        <div class="tendency-text">
          <span>环比</span>
          <img :src="upsAndDowns(item.hb)" />
          <em>{{ percentage(item.hb).toFixed(1) }}%</em>
        </div>
        <div class="tendency-text">
          <span>同比</span>
          <img :src="upsAndDowns(item.tb)" />
          <em>{{ percentage(item.tb).toFixed(1) }}%</em>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@/mixins/common.js'
export default {
  mixins: [common],
  name: 'SmallCard',
  props: [
    'item'
  ],
  data () {
    return {

    }
  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  watch: {

  },
  methods: {

  },
  components: {

  }
}
</script>

<style scoped lang="stylus">
.small-card
  background: #EFF6FF
  border-radius: 8px
  overflow: hidden
  border: 1px solid rgba(0,0,0,0.05);
  .complete-data
    display: flex
  .name
    font-size: 18px;
    font-weight: 400
    line-height: 20px;
    color: rgba(0,0,0,0.8)
  .value
    font-size: 24px;
    line-height: 40px
    font-weight: 600
    padding 0px 10px 0 0
    color: rgba(0,0,0,.8)
  .tendency
    margin-left: auto
  .tendency-text
    font-size: 14px;
    line-height: 18px;
    height: 18px;
    padding-top: 0;
    color: rgba(0,0,0,0.8);
    position: relative;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    white-space: nowrap;
  img
    width: 10px;
    vertical-align: middle;
    margin: 0 2px;

</style>
